export default "__VITE_ASSET__97d9a4e9__"